export default function ShowRoomButton(props) {
	return (
		<button
			className="bg-secondary text-white px-24 py-5  text-lg hover:bg-primary max-sm:px-5"
			onClick={props.handleClick}
		>
			Book a Showroom Visit
		</button>
	);
}
